import { Left, Right } from '@/icons'
import { Text } from '@/local/components'
import { Box, Stack, styled } from '@mui/material'
import { monthSpace, monthWidth } from '../constants'
import type { MonthNavigatorProps as Props } from '../typings'
import { NavigationButton, navigationButtonWidth } from './NavigationButton'

const btnSize = navigationButtonWidth + 6

export function MonthNavigator(props: Props) {
  const { labels, disablePrev, disableNext, onClickPrev, onClickNext, hideNavigation } = props

  const labelWidth =
    labels.length === 2
      ? monthWidth - btnSize
      : labels.length === 1
        ? monthWidth - 2 * btnSize
        : monthWidth

  return (
    <Stack direction="row" justifyContent="center" width="auto" style={{ marginBottom: '12px' }}>
      {!hideNavigation && (
        <NavigationButton
          disabled={disablePrev}
          onClick={onClickPrev}
          data-testid="prev-month"
          data-trackid="calendar-prev-month"
        >
          <Left size={12} />
        </NavigationButton>
      )}
      {labels.map((label, index) =>
        label ? (
          <MonthLabelContainer index={index} width={labelWidth} key={index}>
            <Text uppercase weight="$semiBold" size="$h3" color="$paleSky">
              {label}
            </Text>
          </MonthLabelContainer>
        ) : null,
      )}
      {!hideNavigation && (
        <NavigationButton
          disabled={disableNext}
          onClick={onClickNext}
          data-testid="next-month"
          data-trackid="calendar-next-month"
        >
          <Right size={12} />
        </NavigationButton>
      )}
    </Stack>
  )
}

type MonthLabelContainerProps = {
  index: number
  width: number
}

export const MonthLabelContainer = styled(Box, {
  name: 'MonthLabelContainer',
})<MonthLabelContainerProps>(({ index, width }) => ({
  textAlign: 'center',
  marginLeft: `${index > 0 ? monthSpace : 0}px`,
  width: `${width}px`,
}))
